export default "__VITE_ASSET__3fe0524a__"